import * as React from "react";
import type { SVGProps } from "react";
const SvgShoppingBag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6 2V1a1 1 0 0 0-.8.4zM3 6l-.8-.6A1 1 0 0 0 2 6zm0 14H2zM21 6h1a1 1 0 0 0-.2-.6zm-3-4 .8-.6A1 1 0 0 0 18 1zm-1 8a1 1 0 1 0-2 0zm-5 4v1zm-3-4a1 1 0 0 0-2 0zM5.2 1.4l-3 4 1.6 1.2 3-4zM2 6v14h2V6zm0 14a3 3 0 0 0 .879 2.121l1.414-1.414A1 1 0 0 1 4 20zm.879 2.121A3 3 0 0 0 5 23v-2a1 1 0 0 1-.707-.293zM5 23h14v-2H5zm14 0a3 3 0 0 0 2.121-.879l-1.414-1.414A1 1 0 0 1 19 21zm2.121-.879A3 3 0 0 0 22 20h-2a1 1 0 0 1-.293.707zM22 20V6h-2v14zm-.2-14.6-3-4-1.6 1.2 3 4zM18 1H6v2h12zM3 7h18V5H3zm12 3a3 3 0 0 1-.879 2.121l1.415 1.415A5 5 0 0 0 17 10zm-.879 2.121A3 3 0 0 1 12 13v2a5 5 0 0 0 3.536-1.464zM12 13a3 3 0 0 1-2.121-.879l-1.415 1.415A5 5 0 0 0 12 15zm-2.121-.879A3 3 0 0 1 9 10H7a5 5 0 0 0 1.464 3.536z"
    />
  </svg>
);
export default SvgShoppingBag;
